export default __webpack_public_path__ + "static/media/downArrow.eac952b1.svg";